var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import localeTranslator from 'library/Hocs/LocalTranslator';
import { FormDatePicker, FormInputNumber, FormSelect } from 'components/AntEnhancement/FormControls';
import { DECREASE_ADJUSTMENT, INCREASE_ADJUSTMENT, INTERNAL_MOVEMENT, PURCHASE_MOVEMENT, isAdjustmentMovement } from 'constants/stockMovementTypes';
import InternalMovementForm from './InternalMovementForm';
import PurchaseMovementForm from './PurchaseMovementForm';
import AdjustmentMovementForm from './AdjustmentMovementForm';
import useForceUpdate from 'library/hooks/forceUpdate';
import './style.css';
var Field = function (_a) {
    var label = _a.label, children = _a.children;
    return (_jsxs("div", { className: "smv-form__field", children: [_jsxs("span", { className: "smv-form__label", children: [label, " ", _jsx("span", { className: "smv-form__req", children: "*" })] }), children] }));
};
var StockMovementForm = function (props) {
    var t = props.translate;
    var forceUpdate = useForceUpdate();
    var onChangeProductId = function (productId) {
        if (!productId)
            return;
        props.stockMovement.setProductId(Number(productId));
        if (isAdjustmentMovement(props.stockMovement.getMoveType())) {
            props.stockMovement.setEntityId(0);
        }
        forceUpdate();
    };
    var onChangeStockMovementType = function (type) {
        if (!type)
            return;
        props.stockMovement.setMoveType(type.toString());
        props.stockMovement.setEntityId(0);
        forceUpdate();
    };
    var onChangeQuantity = function (quantity) {
        if (quantity != null)
            props.stockMovement.setQuantity(quantity);
    };
    var onChangePrice = function (price) {
        if (price != null)
            props.stockMovement.setPrice(price);
    };
    var onChangePriceType = function (value) { return props.stockMovement.setPriceType(value.toString()); };
    var onChangeStartedAt = function (startedAt) {
        if (startedAt)
            props.stockMovement.setStartedAt(startedAt.toDate());
    };
    var productOptions = props.products.map(function (product) { return ({
        value: product.getId(),
        title: product.getName()
    }); });
    var metaTypes = props.metaInfo.getStockMovementTypes().map(function (movementType) { return ({
        value: movementType.getValue(),
        title: movementType.getName()
    }); });
    var adjustmentTypes = [
        { value: INCREASE_ADJUSTMENT, title: t('increaseAdjustment') },
        { value: DECREASE_ADJUSTMENT, title: t('decreaseAdjustment') }
    ].filter(function (movementType) { return !metaTypes.some(function (option) { return option.value === movementType.value; }); });
    var typeOptions = __spreadArray(__spreadArray([], metaTypes, true), adjustmentTypes, true);
    var priceTypeOptions = props.metaInfo.getPriceTypes().map(function (priceType) { return ({
        value: priceType.getValue(),
        title: priceType.getName()
    }); });
    var entityForm = function () {
        switch (props.stockMovement.getMoveType()) {
            case INTERNAL_MOVEMENT:
                return _jsx(InternalMovementForm, { stockMovement: props.stockMovement });
            case PURCHASE_MOVEMENT:
                return _jsx(PurchaseMovementForm, { stockMovement: props.stockMovement });
            case INCREASE_ADJUSTMENT:
            case DECREASE_ADJUSTMENT:
                return _jsx(AdjustmentMovementForm, { stockMovement: props.stockMovement });
            default:
                return null;
        }
    };
    return (_jsxs("div", { className: "smv-form", children: [_jsx(Field, { label: t('product'), children: _jsx(FormSelect, { label: t('product'), name: "product", rules: [{ required: true, message: t('errors.product') }], placeHolder: t('product'), onSelect: onChangeProductId, options: productOptions }) }), _jsx(Field, { label: t('movementType'), children: _jsx(FormSelect, { label: t('movementType'), name: "movementType", rules: [{ required: true, message: t('errors.movementType') }], placeHolder: t('movementType'), onSelect: onChangeStockMovementType, options: typeOptions }) }), entityForm(), _jsx(Field, { label: t('quantity'), children: _jsx(FormInputNumber, { label: t('quantity'), name: "quantity", min: 0, rules: [{ required: true, message: t('errors.quantity') }], placeHolder: "0.00", onChange: onChangeQuantity }) }), _jsx(Field, { label: t('price'), children: _jsx(FormInputNumber, { label: t('price'), name: "price", min: 0, rules: [{ required: true, message: t('errors.price') }], placeHolder: "0.00", onChange: onChangePrice }) }), _jsx(Field, { label: t('priceType'), children: _jsx(FormSelect, { label: t('priceType'), name: "priceType", rules: [{ required: true, message: t('errors.priceType') }], placeHolder: t('priceType'), onSelect: onChangePriceType, options: priceTypeOptions }) }), _jsx(Field, { label: t('startedAt'), children: _jsx(FormDatePicker, { label: t('startedAt'), name: "startedAt", rules: [{ required: true, message: t('errors.startedAt') }], placeHolder: t('startedAt'), onChange: onChangeStartedAt }) })] }));
};
export default localeTranslator(StockMovementForm, 'stockMovementForm');
